import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "../../features/posts/postsSlice";
import Aside from "./Aside";
import PostItem from "./PostItem";

const Home = () => {
  const { posts, isLoading, isError, error } = useSelector(
    (state) => state.posts
  );
  const { status, sortBy } = useSelector((state) => state.filter);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchPosts({ status, sortBy }));
  }, [dispatch, status, sortBy]);

  // decide what to render
  let content = null;
  if (isLoading) {
    content = <p>Loading...</p>;
  } else if (posts.length > 0 && !isError && !isLoading) {
    content = posts.map((post) => <PostItem key={post.id} post={post} />);
  } else if (isError && !isLoading && error) {
    content = <p>{error}</p>;
  } else if (!isLoading && !isError && posts.length === 0) {
    content = <p>No posts found</p>;
  }

  return (
    <section className="wrapper">
      <Aside />
      {/* <!-- posts container  --> */}
      <main className="post-container" id="lws-postContainer">
        {content}
      </main>
      {/* <!-- posts container ends --> */}
    </section>
  );
};

export default Home;
